<template>
  <path stroke-linecap="square" d="M18.621 3.065 32.056 16.5M32.056 16.5 18.621 29.935"/>
  <path d="M32.056 16.5H.944"/>
</template>
